var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriStatusCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#4D9CD3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,21h-4l-0.6-2.5c-0.7-0.3-1.3-0.6-1.8-1.1l-2.4,0.8l-2-3.5l1.9-1.7C5,12.7,5,12.4,5,12s0-0.7,0.1-1.1 L3.2,9.2l2-3.5l2.4,0.8c0.5-0.4,1.2-0.8,1.8-1.1L10,3h4l0.6,2.5c0.7,0.3,1.3,0.6,1.8,1.1l2.4-0.8l2,3.5l-1.9,1.7 C19,11.3,19,11.6,19,12s0,0.7-0.1,1.1l1.9,1.7l-2,3.5l-2.4-0.8c-0.5,0.4-1.2,0.8-1.8,1.1L14,21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,12l2,2l4-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriStatusCheck);
export default __webpack_public_path__ + "static/media/PRI_Status_Check.9acde2f6f5e43afb851acdf3e8324875.svg";
export { ForwardRef as ReactComponent };